<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2">Test</h1>
            </div>
            <div>
                <counter
                        v-for="(item, index) in counters"
                        :key="`counter-${index}`"
                        :initial="item"
                        @increment="getTotal"
                        ref="comp"></counter>
                <hr>
                <p>{{ total }}</p>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    import Counter from "../test/Counter";

    export default {
        name: "Test",
        components: {
            Counter
        },

        data() {
            return {
                counters: [1, 4, 9],
                total: 0
            }
        },

        methods: {
            getTotal() {
                this.total = 0;
                this.$refs.comp.forEach(el => this.total = this.total + el.$data.count)
            }
        },

        mounted() {
            this.getTotal();
        }
    }
</script>